import { string, shape, number, arrayOf } from 'prop-types';

const maintenanceFailModeCategoryBasicInformationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
};

const maintenanceFailModeActivityBasicInformationPropTypes = {
  id: number.isRequired,
  name: string.isRequired,
  companyActivityId: string,
  description: string,
  activityType: string,
};

const maintenanceFailModeBasicInformationPropTypes = {
  id: number.isRequired,
  description: string.isRequired,
  categoryId: number.isRequired,
  category: shape(maintenanceFailModeCategoryBasicInformationPropTypes)
    .isRequired,
  subCategoryId: number.isRequired,
  subCategory: shape(maintenanceFailModeCategoryBasicInformationPropTypes)
    .isRequired,
  activityId: number,
  activity: shape(maintenanceFailModeActivityBasicInformationPropTypes),
  priority: string.isRequired,
  createDate: number.isRequired,
};

const maintenanceFailModeCategoryInformationPropTypes = {
  maintenanceFailModeCategoryList: arrayOf(
    shape({
      id: number.isRequired,
      maintenanceFailModeId: number.isRequired,
      name: string.isRequired,
    }),
  ),
};

const maintenanceFailModeActivityInformationPropTypes = {
  maintenanceFailModeActivityList: arrayOf(
    shape({
      id: number.isRequired,
      maintenanceFailModeId: number.isRequired,
      activityId: number,
      activity: shape(maintenanceFailModeActivityBasicInformationPropTypes),
    }),
  ),
};

const maintenanceFailModeBasicInformationDefaultProps = {
  activityId: null,
  activity: null,
};

const maintenanceFailModeCategoryInformationDefaultProps = {
  maintenanceFailModeCategoryList: [],
};

const maintenanceFailModeActivityInformationDefaultProps = {
  maintenanceFailModeActivityList: [],
};

export {
  maintenanceFailModeBasicInformationPropTypes,
  maintenanceFailModeBasicInformationDefaultProps,
  maintenanceFailModeCategoryInformationPropTypes,
  maintenanceFailModeCategoryInformationDefaultProps,
  maintenanceFailModeActivityInformationPropTypes,
  maintenanceFailModeActivityInformationDefaultProps,
};
